export class Tax {
  id: number
  name: string
  type: string
  value?: number
  category: TaxCategory
  constructor(props: Tax) {
    Object.assign(this, props)
  }
}

export const TaxCategory = {
  Article: 'article',
  Customer: 'customer'
}

export type TaxCategory = string

export const TaxType = {
  Percentaje: 'percentaje',
  Map: 'map'
}

export type TaxType = string



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Taxes/Model.ts